import http from './http' // needs this file in the same directory

export default {
  index(params = {}){
    // Construir query string com os parâmetros
    const queryParams = new URLSearchParams();

    // Paginação
    if (params.page) queryParams.append('page', params.page);
    if (params.per_page) queryParams.append('per_page', params.per_page);

    // Ordenação
    if (params.sort_by) queryParams.append('sort_by', params.sort_by);
    if (params.sort_direction) queryParams.append('sort_direction', params.sort_direction);

    // Filtros
    if (params.status) queryParams.append('status', params.status);
    if (params.client_id) queryParams.append('client_id', params.client_id);
    if (params.search) queryParams.append('search', params.search);

    // Filtros de data
    if (params.due_date_from) queryParams.append('due_date_from', params.due_date_from);
    if (params.due_date_to) queryParams.append('due_date_to', params.due_date_to);

    // Filtros de valor
    if (params.amount_from) queryParams.append('ammount_from', params.amount_from);
    if (params.amount_to) queryParams.append('ammount_to', params.amount_to);

    const queryString = queryParams.toString();
    const url = queryString ? `/bills?${queryString}` : '/bills';

    return http.get(url);
  },

  show(bill_id){
    return http.get(`/bills/${bill_id}`);
  },

  update(bill){
    return http.put(`/bills/${bill.id}`,{
      bill: {
        ...bill,
      }
    });
  },

  create_client_bill(client_id, bill){
    return http.post(`/clients/${client_id}/bills`,{
      bill: {
        ...bill,
      }
    });
  },

  client_bill_index(client_id, params = {}){
    // Construir query string para bills de cliente específico
    const queryParams = new URLSearchParams();

    // Paginação
    if (params.page) queryParams.append('page', params.page);
    if (params.per_page) queryParams.append('per_page', params.per_page);

    // Ordenação
    if (params.sort_by) queryParams.append('sort_by', params.sort_by);
    if (params.sort_direction) queryParams.append('sort_direction', params.sort_direction);

    // Filtros
    if (params.status) queryParams.append('status', params.status);
    if (params.search) queryParams.append('search', params.search);

    // Filtros de data
    if (params.due_date_from) queryParams.append('due_date_from', params.due_date_from);
    if (params.due_date_to) queryParams.append('due_date_to', params.due_date_to);

    // Filtros de valor
    if (params.amount_from) queryParams.append('ammount_from', params.amount_from);
    if (params.amount_to) queryParams.append('ammount_to', params.amount_to);

    const queryString = queryParams.toString();
    const url = queryString ? `/clients/${client_id}/bills?${queryString}` : `/clients/${client_id}/bills`;

    return http.get(url);
  },

  client_bill_show(client_id, bill_id){
    if (client_id)
      return http.get(`/clients/${client_id}/bills/${bill_id}`);
    else
      return http.get(`/bills/${bill_id}`);
  },
}